import API from "../../api/chartservice";
import router from "../../router/index";
import axios from "axios";

const state = {
  isFullScreen: false,
};

const getters = {
  isFullScreen: (state) => state.isFullScreen,
};

const actions = {
  // peelhunt sectors dropdwon data api integration
  async getPeelhuntSectorsData({ commit, dispatch }, chartinfo) {
    try {
      let response = {};
      response = await API.getPeelhuntSectorsNameList();
      const responsedata = response && response.data;
      return responsedata;
    } catch (error) {
      console.log( error.response);
      if (
        error &&
        error.response &&
        error.response.status &&
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async getPeelhuntTableData({ commit, dispatch }, data) {
    try {
      let response = {};
      response = await API.getPeelhuntTableList(data);
      // console.log("response-===-", response.data);
      const responsedata = response && response.data && response.data;
      return responsedata;
    } catch (error) {
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
        //this.$router.push('/logout');
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async customIndexAPIHandler({ commit, dispatch }, data) {
    try {
      let response = {};
      // const data = data.data
      response = await API.getPeelhuntPricePerformanceData(data, "GetCustomIndex");
      // console.log("response-===-", response);
      const responsedata = response && response.data;
      //console.log('chartName-==-=-',chartname);
      return responsedata;
    } catch (error) {
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
        //this.$router.push('/logout');
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async getCustomIndexDropdown({ commit, dispatch }, chartinfo) {
    try {
      let response = {};
      response = await API.getCustomIndexDropdown();
      const responsedata = response && response.data;
      return responsedata;
    } catch (error) {
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async getRiskAdjustedTableData({ commit, dispatch }, chartinfo) {
    try {
      let response = {};
      response = await API.getPeelhuntPricePerformanceData(chartinfo, 'GetRiskAdjustedReturn');
      // console.log("response-===-", response.data.data);
      const responsedata = response && response.data;
      return responsedata;
    } catch (error) {
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
  async getPricePerformanceToggel({ commit, dispatch }, chartinfo) {
    try {
      let response = {};
      // console.log("chartinfo++++++>>>>>>", chartinfo);
      response = await API.getPeelhuntPricePerformanceData(chartinfo, 'GetPricePerformance');
      // console.log("response-===-", response.data.data);
      const responsedata = response && response.data;
      return responsedata;
    } catch (error) {
      console.log(error);
      if (
        typeof error.response.status != "undefined" &&
        error.response.status === 401
      ) {
        router.push({ name: "logout" });
      }
      commit("SET_ERROR", error);
      return error;
    }
  },
};
const mutations = {
  SET_FULLSCREEN_STATUS: (state, fullscreen) => {
    state.isFullScreen = fullscreen;
  },
};
export default {
  state,
  getters,
  actions,
  mutations,
};
